<template>
  <div>
    <v-row class="mx-0">
      <v-col cols="6" class="px-3 mt-1">
        <v-btn
          color="primary"
          height="40"
          class="me-2"
          small
          outlined
          @click="addCheckRow"
        >
          {{ $t("addRow") }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-for="(check, i) in checkItems" :key="i" class="mx-0">
      <v-col cols="12" md="1" style="max-width: 50px">
        <p class="my-2">{{ i + 1 }} )</p>
      </v-col>
      <v-col md="11">
        <v-row>
          <v-col class="px-3 xs" cols="12" md="2">
            <autocomplete
              v-model="check.account"
              :rules="[(v) => !!v || $t('is-required')]"
              :title="type == 'pay' ? $t('reciever') : $t('payer')"
              type="person"
              :new-btn="true"
              :value="check.account"
            />
          </v-col>
          <v-col cols="12" md="2">
            <money
              v-model="check.amount"
              :disabled="isCheckLocked(check)"
              :label="$t('amount')"
              :dense="true"
              :outlined="true"
              :rules="[(v) => !!v || $t('is-required')]"
              :solo="false"
              :clearable="true"
              value-when-is-empty=""
              :options="options"
              :value-options="{
                max: check.bank
                  ? Number(check.bank.remain.currency_remain)
                  : 9999999999999999999,
              }"
            />
          </v-col>
          <v-col cols="12" md="2" sm="2">
            <template>
              <v-text-field
                :id="'checkDate' + i"
                :disabled="isCheckLocked(check)"
                v-model="check.date"
                :label="$t('date') + ' ' + $t('issue')"
                :rules="[(v) => !!v || $t('is-required')]"
                clear-icon="flaticon2-close-cross"
                outlined
                dense
                clearable
              />
              <date-picker
                v-model="check.date"
                :element="'checkDate' + i"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                auto-submit
                :min="$store.state.startDate"
                :max="$store.state.endDate"
                :color="
                  $vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary
                "
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col cols="12" md="2" sm="2">
            <template>
              <v-text-field
                :disabled="isCheckLocked(check)"
                :id="'checkdueDate' + i"
                v-model="check.dueDate"
                :label="$t('dueDate')"
                clear-icon="flaticon2-close-cross"
                outlined
                :rules="[(v) => !!v || $t('is-required')]"
                dense
                clearable
                @keyup="check.dueDate = null"
              />
              <date-picker
                v-model="check.dueDate"
                :element="'checkdueDate' + i"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                auto-submit
                :color="
                  $vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary
                "
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col cols="12" sm="2" md="2">
            <v-select
              :disabled="isCheckLocked(check)"
              v-model="check.kind"
              :label="$t('kind') + ' ' + $t('check')"
              :items="kindItems"
              :rules="[(v) => !!v || $t('is-required')]"
              height="30"
              dense
              outlined
              item-value="value"
              item-text="text"
            />
          </v-col>
          <v-col v-if="type == 'recieveCheck'" cols="12" md="2" sm="2" class="mb-0">
            <v-text-field
              v-model="check.number"
              :disabled="isCheckLocked(check)"
              :label="$t('number') + ' ' + $t('check')"
              height="20"
              :rules="[(v) => !!v || $t('is-required')]"
              dense
              outlined
              class="mb-1 dense"
              clearable
            />
          </v-col>
          <v-col cols="12" md="2" sm="2" class="mb-0">
            <v-text-field
              v-model="check.fishermanNumber"
              :label="$t('fishermanNumber')"
              :disabled="isCheckLocked(check)"
              height="20"
              dense
              outlined
              class="mb-1 dense"
              clearable
            />
          </v-col>
          <v-col v-if="type == 'payCheck'" cols="12" sm="4" md="4">
            <autocomplete
              v-model="check.check"
              :rules="[(v) => !!v || $t('is-required')]"
              :title="$t('check')"
              type="payCheck"
              @input="onCheckSelected(check, $event)"
            />
          </v-col>
          <v-col v-if="type == 'recieveCheck'" cols="12" md="2" sm="2" class="mb-0">
            <v-text-field
              v-model="check.bankName"
              :disabled="isCheckLocked(check)"
              :label="$t('name') + ' ' + $t('bank')"
              height="20"
              dense
              :rules="[(v) => !!v || $t('is-required')]"
              outlined
              class="mb-1 dense"
              clearable
            />
          </v-col>
          <v-col v-if="type == 'recieveCheck'" cols="12" md="2" sm="2" class="mb-0">
            <v-text-field
              v-model="check.bankAccountNumber"
              :disabled="isCheckLocked(check)"
              :label="$t('number') + ' ' + $t('account')"
              height="20"
              dense
              outlined
              class="mb-1 dense"
              clearable
            />
          </v-col>
          <v-col v-if="type == 'recieveCheck'" cols="12" sm="2" md="2">
            <autocomplete
              v-model="check.cashBox"
              :disabled="isCheckLocked(check)"
              :title="$t('cashBox')"
              type="getCash"
              :currency-prop="
                formHeader.currency ? formHeader.currency.id : $store.state.currency.id
              "
            />
          </v-col>
          <v-col cols="12" sm="2" md="2">
            <aicomplete
              v-model="check.branch"
              title="branch"
              type="branch"
              :set-init="true"
              :new-btn="true"
            />
            <!-- :disabled="isCheckLocked(check)" -->
          </v-col>
          <v-col cols="12" md="1" offset-md="1">
            <v-btn
              color="pink"
              small
              outlined
              class="float-end"
              height="32"
              @click="removeRow(i)"
            >
              <v-icon> mdi-trash-can-outline </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" class="mt-2">
        <v-divider />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import General from "@/Mixins/general";
export default {
  name: "CompositeHeader",
  mixins: [General],
  props: ["formHeader", "type"],
  data() {
    return {
      checkItems: [],
      kindItems: null,
      options: {
        locale: "en-US",
        prefix: "",
        suffix: "  ",
        precision: 0,
      },
    };
  },
  computed: {
    totalAmount() {
      return this.checkItems.reduce((sum, check) => {
        return +sum + +(check.amount || 0);
      }, 0);
    },
  },
  watch: {
    $data: {
      handler(newVal, oldVal) {
        this.emitData();
      },
      deep: true,
    },
  },
  mounted() {
    this.kindItems = [
      {
        value: "normal",
        text: this.$t("normal"),
      },
      {
        value: "guarantee",
        text: this.$t("guarantee"),
      },
    ];
  },
  methods: {
    removeRow(i) {
      this.checkItems.splice(i, 1);
    },
    emitData() {
      var data = {
        totalAmount: this.totalAmount,
        items: this.checkItems,
      };
      this.$emit("input", data);
    },
    addCheckRow() {
      var check = {
        type: this.type,
        date: this.formHeader ? this.formHeader.date : null,
        dueDate: null,
        account: this.formHeader ? this.formHeader.account : null,
        fishermanNumber: null,
        bankAccountNumber: null,
        cashBox: null,
        bankName: null,
        check: null,
        number: null,
        kind: null,
        amount: null,
        bank: null,
        given: null,
        content: null,
        branch: null,
      };
      this.checkItems.push(check);
    },
    clearForm() {
      this.checkItems = [];
    },

    isCheckLocked(check) {
      return this.type === "payCheck" && !!check.check && check.check.type === "customer";
    },
    onCheckSelected(row, selected) {
      if (!selected) return;
      row.amount = Number(selected.amount);
      row.date = selected.date;
      row.dueDate = selected.due_date;
      row.kind = selected.kind;
      row.number = selected.number;
      row.fishermanNumber = selected.fisherman_number;
      row.bankName = selected.bank_name;
      row.bankAccountNumber = selected.bank_account_number;
      // row.account = selected.account_id
      row.cashBox = selected.cash_id;
      if (selected.branch) {
        row.branch = selected.branch;
      }
    },
  },
};
</script>

<style scoped></style>
